"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTopNotification = createTopNotification;

function createTopNotification(type, message) {
  var sticky = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    position: 'top',
    type: type,
    message: message,
    sticky: sticky
  };
}